module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[71]436.b46e724.woff2";